import React, { Component } from "react";
import { TableDefault, LabelString, LabelDate } from "@loanbossinc/component-library";
import styled from "styled-components";
import ClearIcon from '@material-ui/icons/Clear';

const StyledTableDefault = styled(TableDefault)`
&& {
  border-radius: 0px; 
  tr:last-child {
    td {
      border-bottom: #DADCE0 1px solid;
    }
  }
}`;

const StyledButton = styled(ClearIcon)`
&& {
  padding-left: 0.3em;
  color: #005AA9;
  height: 30px;
  width: 30px;
  cursor: pointer;
  color: #C40A0A;
}`;

export class PeopleGuestDataTable extends Component {
  peopleGuestCols = () => {
    return [
      {
        id: 'userDetails'
        , label: 'GUEST NAME'
        , path: 'userDetails'
        , Cell: (value) => (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <LabelString style={{ color: "#000", fontWeight: "500" }} value={value.name} />
            <LabelString style={{ color: "#5F6368", fontSize: "12px" }} value={value.companyName} />
          </div>
        )
      }
      , {
        id: 'invitedBy'
        , label: 'INVITED BY'
        , path: 'invitedBy'
        , Cell: (value) => <LabelString value={value} />
      }
      , {
        id: 'permission'
        , label: 'PERMISSIONS'
        , path: 'permission'
        , Cell: (value) => <LabelString value={value} />
      }
      , {
        id: 'dateInvited'
        , label: 'DATE INVITED'
        , path: 'dateInvited'
        , Cell: (value) => (
          <div style={{ display: "flex", alignItems: "center" }}>
            <LabelDate value={value.dateInvited} />
            <StyledButton onClick={() => value.onDelete()} />
          </div>
        )
      }
    ]
  }

  getColumnData = () => {
    const { guestList } = this.props;

    return guestList.reduce((acc, cur) => {
      if (!cur) return null;
      acc.push({
        userDetails: {
          name: `${cur.firstName} ${cur.lastName}`
          , companyName: cur.company
        }
        , invitedBy: `${cur.invitedBy.firstName} ${cur.invitedBy.lastName}`
        , permission: cur.portfolioPermission ? this.guestAccessFormatter(cur.portfolioPermission.value) : "None"
        , dateInvited: {
          dateInvited: cur.dateInvited
          , guestId: cur.id
          , onDelete: () => this.props.onDeleteGuest(cur)
        }
      })
      return acc;
    }, []);
  }

  guestAccessFormatter = (accessValue) => {
    if (accessValue === "View") return `${accessValue} only`;
    if (accessValue === "Edit") return `View/${accessValue}`;
    return "None";
  }

  render() {
    return (
      <StyledTableDefault
        elevation={0}
        columns={this.peopleGuestCols()}
        items={this.getColumnData()}
      />
    )
  }
}
